<template>
  <div class="payment-overdue-hint">
    <div class="text-negative q-body-2 q-mr-md cursor-pointer">
      Offene Rechnungen
      <q-tooltip>
        Die Zahlung für Ihr {{ isMainPackage ? 'Abonnement' : 'Zusatzpaket' }} ist fehlgeschlagen.<br>
        Bitte begleichen Sie die offenen Rechnungen bis {{ deadlineText }}.<br>
        Sollten die Rechnungen bis dahin nicht beglichen sein, wird der Zugang zu Autengo gesperrt.
      </q-tooltip>
    </div>
    <q-btn
      class="q-mr-lg no-shadow"
      outline
      size="md"
      color="negative"
      label="Jetzt bezahlen"
      @click="openInvoices"
    />
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import OpenInvoicesModal from '@/components/payment/OpenInvoicesModal.vue';

export default {
  name: 'PaymentOverdueHint',
  computed: {
    ...mapGetters('subscription', ['mainPackages', 'unpaidSubscriptions', 'paymentDeadline']),
    isMainPackage() {
      return this.mainPackages.includes(this.unpaidSubscriptions[0]?.packageKey);
    },
    deadlineText() {
      return moment(this.paymentDeadline).format('DD.MM.YYYY HH:mm');
    },
  },
  methods: {
    openInvoices() {
      this.$q.modal(OpenInvoicesModal).catch(() => {});
    },
  },
};
</script>

<style scoped>
.payment-overdue-hint {
  display: contents;
}
</style>
